<!--  -->
<template>
  <div class="footer">
    <div class="footer-row">
      <h1 class="footer-logo"><img src="../assets/images/tumile-logo-1.png" alt=""></h1>
      <div class="footer-icon">
        <!-- <a href="https://play.google.com/store/apps/details?id=com.rcplatform.livechat" target="_blank" class="footer-i google">Google play</a> -->
         <a href="https://play.google.com/store/apps/details?id=com.videochat.livu" target="_blank" class=""><img class="img-app" src="../assets/images/google.png"/></a>
        <!-- <a href="#" class="footer-i ios">App store</a> -->
      </div>
    </div>
    <div class="footer-row only-text">
      <p class="footer-links">
        <a href="https://privacy.tumile.me/LiveChat_privacy.html" target="_blank">Privacy Policy</a>
        <a href="https://privacy.tumile.me/LiveChat_us_privacy.html" target="_blank">US State Privacy Rights</a>
        <a href="https://privacy.tumile.me/LiveChat_termsofservice.html" target="_blank">Terms and Conditions</a>
        <a href="https://privacy.tumile.me/tumile_dsa_help_center.html" target="_blank">DSA help center</a>
      </p>
      <p>Copyright Tumile ©2019</p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}

</script>
<style lang='scss' scoped>
@import '@/assets/style/vars.scss';
@media (min-width: 750px) {
  .footer {
    background: url('../assets/images/background.png') no-repeat;
    background-size:  100% 100%;
    width: 100%;
    height: 140px;
    padding: 30px 0;
    position: absolute;
    .footer-logo {
      width: 94px;
      img {
        max-width: 100%;
      }
    }
    .footer-row {
      max-width: 1400px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .only-text p {
      color: #fff;
      font-size: 16px;
      padding-top: 20px;
      a {
        color: #fff;
      }
    }
    .footer-links {
      a {
        margin-right: 20px;
      }
    }
    .footer-icon {
      display: flex;
      .img-app{
        width: 180px;
        height:60px;
        margin-right: 20px;
      }
      .footer-i {
        width: 180px;
        height: 42px;
        padding-left: 30px;
        background-color: #fff;
        border-radius: 21px;
        margin-left: 20px;
        color: $primary;
        box-shadow:4px 4px 21px 0px rgba(0,0,0,0.08);
        text-align: center;
        line-height: 42px;
        font-size: 16px;
        position: relative;
        text-decoration: none;
        &.google::before {
          content: '';
          position: absolute;
          top: 11px;
          left: 27px;
          background: url('../assets/images/google-icon.png') no-repeat;
          background-size: 100%;
          width: 20px;
          height: 24px;
        }
        &.android::before {
          content: '';
          position: absolute;
          top: 11px;
          left: 30px;
          background: url('../assets/images/android-icon.png') no-repeat;
          width: 20px;
          height: 22px;
        }
        &.ios::before {
          content: '';
          position: absolute;
          top: 5px;
          left: 25px;
          background: url('../assets/images/ios-icon.png') no-repeat;
          width: 32px;
          height: 32px;
        }
      }
    }
  }
}
@media (max-width: 750px) {
  .footer {
    background: url('../assets/images/background.png') no-repeat;
    background-size:  100% 100%;
    padding: 10px 20px;
    width: 100%;
    .footer-logo {
      width: 64px;
      img {
        max-width: 100%;
      }
    }
    .footer-row {
      text-align: left;
    }
    .only-text {
      margin-top: 10px;
    }
    .only-text p {
      color: #fff;
      font-size: 12px;
      padding-top: 10px;
      a {
        color: #fff;
      }
    }
    .footer-links {
      display: flex;
      flex-direction: column;
      a {
        margin-bottom: 8px;
      }
    }
    .footer-icon {
      display: flex;
      margin-top: 12px;
      .img-app{
        width: 100px;
        height: 35px;
        margin-right: 10px;
      }
      .footer-i {
        width: 143px;
        height: 33px;
        padding-left: 20px;
        background-color: #fff;
        border-radius: 21px;
        margin-right: 20px;
        color: $primary;
        box-shadow:4px 4px 21px 0px rgba(0,0,0,0.08);
        text-align: center;
        line-height: 33px;
        font-size: 12px;
        font-weight: bold;
        position: relative;
        text-decoration: none;
        &.google::before {
          content: '';
          position: absolute;
          top: 7px;
          left: 20px;
          background: url('../assets/images/google-icon.png') no-repeat;
           background-size: 100%;
          width: 18px;
          height: 22px;
        }
        &.android::before {
          content: '';
          position: absolute;
          top: 6px;
          left: 25px;
          background: url('../assets/images/android-icon.png') no-repeat;
           background-size: 100%;
          width: 22px;
          height: 22px;
        }
        &.ios::before {
          content: '';
          position: absolute;
          top: 5px;
          left: 25px;
          background: url('../assets/images/ios-icon.png') no-repeat;
          background-size: 100%;
          width: 22px;
          height: 22px;
        }
      }
    }
  }
}
</style>
